import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: string;
  title: string;
  summary: string;
  publishDate: string;
  image: string;
  tags: string[];
  views: number;
  variant?: 'default' | 'horizontal';
}

export default function ArticleCard({
  id,
  title,
  summary,
  publishDate,
  image,
  tags,
  views,
  variant = 'default',
}: ArticleCardProps) {
  if (variant === 'horizontal') {
    return (
      <Link to={`/article/${id}`} className="group flex gap-4 p-3 rounded-lg hover:bg-background-100 transition-colors">
        <div className="w-40 h-24 flex-shrink-0 rounded-md overflow-hidden bg-background-200">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex-1 min-w-0 flex flex-col justify-between">
          <div>
            <h4 className="text-sm font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
              {title}
            </h4>
            <p className="mt-1 text-xs text-foreground-500 line-clamp-2">
              {summary}
            </p>
          </div>
          <div className="flex items-center gap-2 mt-2 text-[11px] text-foreground-400">
            <span>{publishDate}</span>
            <span>·</span>
            <span>{formatViews(views)} 阅读</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link to={`/article/${id}`} className="group block">
      <div className="relative overflow-hidden rounded-lg aspect-[16/10] bg-background-200">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="mt-3">
        <div className="flex items-center gap-1.5 flex-wrap mb-2">
          {tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="text-[10px] text-secondary-700 bg-secondary-100 rounded px-1.5 py-0.5 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-2">
          {summary}
        </p>
        <div className="flex items-center gap-2 mt-2 text-[11px] text-foreground-400">
          <span>{publishDate}</span>
          <span>·</span>
          <span>{formatViews(views)} 阅读</span>
        </div>
      </div>
    </Link>
  );
}

function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return views.toString();
}